export default __webpack_public_path__ + "static/media/tri-fold-brochure-june.442c8c14.pdf";